import React from "react";
import Cookies from "js-cookie";

const MobileBlock = () => {
  const signOut = () => {
    [
      "userId",
      "userType",
      "userName",
      "userEmail",
      "userPhone",
      "userPassword",
      "userOrg",
      "userPermissions",
      "userAnonymous",
    ].forEach((k) => Cookies.remove(k));
    // A document load on purpose, for the reason given at the sign-out in
    // App.js: clearing cookies does not clear mounted state.
    window.location.href = "/";
  };

  return (
    <>
      <style>{`
        .mobile-block-page {
          min-height: 100vh;
          background: linear-gradient(135deg, rgba(0,0,0,1) 0%, rgba(255,98,0,1) 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 24px;
          position: relative;
          overflow: hidden;
        }
        .mobile-block-texture {
          position: absolute;
          inset: 0;
          background-image: url('/images/background-art.jpg');
          background-repeat: repeat;
          background-size: 400px 400px;
          background-position: center;
          mix-blend-mode: overlay;
          opacity: 0.05;
          pointer-events: none;
        }
        .mobile-block-card {
          position: relative;
          z-index: 1;
          background: #fff;
          border-radius: 22px;
          border: 1px solid rgba(255,255,255,0.15);
          box-shadow: 0 24px 64px rgba(0,0,0,0.35);
          padding: 40px 32px 36px;
          max-width: 380px;
          width: 100%;
          text-align: center;
        }
        .mobile-block-icon-ring {
          width: 80px;
          height: 80px;
          border-radius: 20px;
          background: rgba(255,81,0,0.08);
          border: 2px solid rgba(255,81,0,0.18);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 24px;
        }
        .mobile-block-title {
          font-size: 20px;
          font-weight: 800;
          color: #111827;
          margin-bottom: 10px;
          letter-spacing: -0.3px;
        }
        .mobile-block-body {
          font-size: 14px;
          color: #6b7280;
          line-height: 1.65;
          margin-bottom: 30px;
        }
        .mobile-block-signout {
          width: 100%;
          padding: 13px 0;
          border-radius: 12px;
          border: none;
          background: linear-gradient(135deg, #c13d00 0%, #ff5100 100%);
          color: #fff;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          transition: opacity 0.15s;
        }
        .mobile-block-signout:hover {
          opacity: 0.88;
        }
        .mobile-block-divider {
          height: 1px;
          background: #f3f4f6;
          margin: 24px 0;
        }
        .mobile-block-footer {
          font-size: 11px;
          font-weight: 700;
          color: #d1d5db;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
      `}</style>

      <div className="mobile-block-page">
        <div
          className="mobile-block-texture"
          aria-hidden
        />

        <div className="mobile-block-card">
          <img
            src="/images/bleeplogo_primary.png"
            alt="Bleep"
            style={{
              height: 32,
              width: "auto",
              objectFit: "contain",
              marginBottom: 28,
            }}
          />
          <div className="mobile-block-icon-ring">
            <i
              className="fas fa-desktop"
              style={{ fontSize: 32, color: "#ff5100" }}
            />
          </div>

          <div className="mobile-block-title">Larger Screen Required!</div>
          <div className="mobile-block-body">
            Please switch to a desktop/laptop to access this resource. This
            section of BLEEP is optimized for larger screens.
          </div>

          <button
            className="mobile-block-signout"
            onClick={signOut}
          >
            <i
              className="fas fa-sign-out-alt"
              style={{ fontSize: 14 }}
            />
            Sign Out
          </button>

          <div className="mobile-block-divider" />
          <div className="mobile-block-footer">Bleep Admin</div>
        </div>
      </div>
    </>
  );
};

export default MobileBlock;
